import React from 'react'
import { UserCell } from '../UserCell'

function ManyUsersCell({ values, data }: { values: (any & { id: string })[], data: any }) {
  return <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    {values.map((value) => <UserCell key={value.id} value={value} data={data} />)}
  </div>
}

export { ManyUsersCell }
